import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';

const moment = _rollupMoment || _moment;

let RDS_MOMENT_JS_CHECKED = false;
const RDS_MOMENT_JS_ERROR_MESSAGE = `@mtna/rds-lib-ui
- Cannot find moment.js, make sure to install the dependency and add the script in angular.json, i.e.
"scripts": ["node_modules/moment/min/moment.min.js"]`;

/**
 * Check and see if momentjs has been set up correctly in the consuming application.
 * Otherwise log an error.
 */
export function _rdsVerifyMomentJsExists() {
  if (!RDS_MOMENT_JS_CHECKED) {
    RDS_MOMENT_JS_CHECKED = true;
    try {
      if (!moment || typeof moment !== 'function') {
        throw Error(RDS_MOMENT_JS_ERROR_MESSAGE);
      }
    } catch {
      throw Error(RDS_MOMENT_JS_ERROR_MESSAGE);
    }
  }
}
